module.exports = __webpack_public_path__ + "img/colored-rounded.e710a000.svg";